module.exports = __webpack_public_path__ + "static/media/banner1.c60deb30.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/v2/banner1.png
// module id = 679
// module chunks = 2